<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<script setup>
const storeApp = useStoreApp();
await useAsyncData('initApp', () => storeApp.initApp().then(() => true));

onMounted(function () {
    window.addEventListener('focus', storeApp.focusApp);
    window.addEventListener('blur', storeApp.blurApp);
    storeApp.mountApp();
});

// Sets default seo properties for efficient bundling of seo composable
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: $config.public.siteName,
    description: $config.public.siteStrapline,
    index: false,
});
</script>
